import { styled, FormControl } from "@material-ui/core";
import Rating from "components/rating";
import { brand } from "../../../theme";
import { FormLabel } from "../styles/shared";

export const RatingField = styled(({ rating, onChange, ...p }) => (
    <FormControl margin="normal" fullWidth {...p}>
        <FormLabel>Rating</FormLabel>
        <div className="card">
            <Rating rating={rating} onChange={onChange} type="edit" />
        </div>
    </FormControl>
))(({ theme }) => ({
    marginTop: theme.spacing(3),
    "& .card": {
        background: brand.white,
        borderRadius: 12,
        padding: theme.spacing(1, 2),
        boxShadow: "0 1px 4px rgba(26,18,5,0.06)",
    },
    "& .MuiFormControlLabel-root": {
        marginLeft: 0,
    },
    "& .MuiFormControlLabel-label": {
        fontWeight: 500,
        color: brand.text,
    },
}));
